import React, { useState } from 'react'
import { NavLink } from 'react-router-dom';
import { useEffect } from 'react';

function PrimaryButtonLight(props) {

    const [title, setTitle] = useState("N/A");
    const [link, setLink] = useState("link");

    useEffect(() => {
        setTitle(props.title);
        setLink(props.link);
    }, []);

    return (

        <NavLink to={`/${link}`} className={`rounded-full justify-center items-center border border-secondary border-solid py-4 px-8 text-button text-secondary hover:bg-secondary hover:border-secondary hover:text-primary transition ease-in duration-200`}>
            {title}
        </NavLink>
    )
}

export default PrimaryButtonLight